import PropTypes from "prop-types";
import React from "react";
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

import logo from "../../assets/images/Logo.png";
import logo2 from "../../assets/images/Logo2.png";
import ConfigUrl from "../../config"

const Sidebar = props => {

  return (
    <React.Fragment>
      <div className="vertical-menu" id="vertical-menu">
        <div className="d-lg-flex d-md-none navbar-brand-box justify-content-center">
          <Link to={`${ConfigUrl.appurl}`} className="logo logo-dark w-100">
            <span className="logo-sm">
              <img src={logo2} alt="" height="50" className="bg-white rounded-3 p-1" />
            </span>
            <span className="logo-lg w-100">
              <img src={logo} alt="" height="75" className="w-100 object-fit-cover rounded-3 bg-white p-1"/>
            </span>
          </Link>

          <Link to={`${ConfigUrl.appurl}`} className="logo logo-light">
            <span className="logo-sm">
              <img src={logo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="" height="19" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};


export default (withRouter(withTranslation()(Sidebar)));
